import { render } from "./DssIcon.vue?vue&type=template&id=c02cfc08&scoped=true&ts=true"
import script from "./DssIcon.vue?vue&type=script&lang=ts"
export * from "./DssIcon.vue?vue&type=script&lang=ts"

import "./DssIcon.vue?vue&type=style&index=0&id=c02cfc08&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02cfc08"]])

export default __exports__